import { render } from "./WebhooksList.vue?vue&type=template&id=66974a1e&scoped=true"
import script from "./WebhooksList.vue?vue&type=script&lang=js"
export * from "./WebhooksList.vue?vue&type=script&lang=js"

import "./WebhooksList.vue?vue&type=style&index=0&id=66974a1e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66974a1e"]])

export default __exports__